import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';

var USER_TOKEN_COOKIE = "user-token"; // https://stackoverflow.com/questions/10730362/get-cookie-by-name

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  return parts.length == 2 ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  parts.pop().split(";").shift() : undefined;
} // eslint-disable-next-line @typescript-eslint/explicit-function-return-type

var getUserTokenCookie = function () {
  return getCookie(USER_TOKEN_COOKIE);
};

/**
 * quick check to see if the user has been authenticated
 * Note, this is not a secure check
 */

var isAuthenticated = function () {
  return getCookie(USER_TOKEN_COOKIE) != null;
};

var NATIVE_QUERY_STRING_IDENTIFIER = "native";

var hasNativeQueryParam = function () {
  var reg = new RegExp("[?&]" + NATIVE_QUERY_STRING_IDENTIFIER + "=", "i");
  var hasNative = reg.exec(window.location.href);
  return hasNative !== null;
}; // isNative = true when userAgent has "odin-mobile-app" string or
// has 'native' query param in url


var isNative = function () {
  var _context;

  return typeof window !== "undefined" && (_indexOfInstanceProperty(_context = window.navigator.userAgent).call(_context, "odin-mobile-app") >= 0 || hasNativeQueryParam());
};

export { USER_TOKEN_COOKIE, getCookie, getUserTokenCookie, isAuthenticated, isNative };
